export default __webpack_public_path__ + "static/image7-40064f2dcc698a99a8a7d584d5abb956.jpeg";